'use strict'

desktopErrorMessageTemplate = require '../../error_message.html.mustache'
desktopErrorHtmlPresenter = require '../presenters/error'

module.exports =
  render: ->
    desktopErrorMessageTemplate.render desktopErrorHtmlPresenter.toHash()
